
import { Component, Vue } from 'vue-property-decorator'
import { StationClient } from '@/api'
import StationEditor from './editor.vue'
import BaseList from '@/views/BaseList'
import _ from 'lodash'
import { setTimeout } from 'timers'

@Component({
  name: 'StationList',
  components: {
    StationEditor
  }
})
export default class extends BaseList {
  public constructor() {
    super()
    this.client = new StationClient()
    this.listQuery = {
      filter: {
        where: {
          name: { like: '' },
          id: this.$store.state.user.stationId
        },
        fields: {
          // id: true,
          // name: true,
          // cover: true,
          // address: true,
          // latitude: true,
          // longitude: true,
          // createdAt: true
        },
        limit: 10,
        page: 1,
        skip: 0,
        order: ['createdAt']
      }
    }
  }

  async created() {
    super.created()
    console.log(this.$store.state.stationId)
  }

  protected generateQuery():any {
    const t = _.cloneDeep(this.listQuery)
    t.filter.where.name.like = `%${this.listQuery.filter.where.name.like}%`
    return t
  }

  protected async handleFilter() {
    super.handleFilter()
  }

  protected async handleUpdate(row: any) {
    super.handleUpdate(row)
  }

  protected async saveData() {
    super.saveData()
  }
}
